import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Nav } from './components/site/Nav';
import { Footer } from './components/site/Footer';
import { Home } from './pages/Home';
import { Methodology } from './pages/Methodology';
import { Company } from './pages/Company';
import { CompliancePage } from './pages/Compliance';
import { DemoRedirect } from './pages/DemoRedirect';
import { applyDocumentMetadata, guardDocumentMetadata } from './utils/metadata';

/** Routed pages should open at the top, not at the previous scroll position. */
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    applyDocumentMetadata();
  }, [pathname]);
  return null;
}
export function App() {
  // Title and social tags are owned by the app, never derived from the project
  // or prompt name. The guard re-asserts them if anything overwrites the head.
  useEffect(() => {
    applyDocumentMetadata();
    return guardDocumentMetadata();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="3ijfthv617oci">
      <div className="w-full bg-bone font-sans text-ink" data-id="element-1" data-mp="3ii4t85bsoyq5">
        <ScrollToTop data-id="element-2" data-mp="3mk86mzi0yde2" />
        <Nav data-id="element-3" data-mp="3mjq2zht18ww4" />
        <main data-id="element-4" data-mp="3mj6ibtbzzuee">
          <Routes data-id="element-5" data-mp="3rc9co3oln7vn">
            <Route path="/" element={<Home data-id="element-7" data-mp="3rdkie91luppe" />} data-id="element-6" data-mp="3rbrcivytg9ig" />
            <Route path="/methodology" element={<Methodology data-id="element-9" data-mp="5or2zhbcs60" />} data-id="element-8" data-mp="3rd189ei755lx" />
            <Route path="/compliance" element={<CompliancePage data-id="element-11" data-mp="82ld64660ci" />} data-id="element-10" data-mp="4wwnrzgd0hb" />
            <Route path="/company" element={<Company data-id="element-13" data-mp="2zm4v0cs84yy4" />} data-id="element-12" data-mp="2zld259q0hfbj" />
            <Route path="/demo" element={<DemoRedirect data-id="element-15" data-mp="33movnqc0akp0" />} data-id="element-14" data-mp="2zmwhmy3ufmc9" />
            <Route path="/demo/" element={<DemoRedirect data-id="element-17" data-mp="33n6wl09m5n39" />} data-id="element-16" data-mp="33lx0uhq8gqzs" />
          </Routes>
        </main>
        <Footer data-id="element-18" data-mp="38li8dgjgy7o4" />
      </div>
    </BrowserRouter>;
}